import { render, staticRenderFns } from "./Europe.vue?vue&type=template&id=fa990b7e&"
import script from "./Europe.vue?vue&type=script&lang=js&"
export * from "./Europe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports